const type = 'SET_AGREEMENT_CONCLUSION';

const setAgreementConclusion = (data) => ({
  data,
  type,
});

export { type };
export default setAgreementConclusion;
